const shadows = {
  size1: '0 1px 2px 0 rgba(0, 0, 0, 0.10)',
  size2: '0 2px 4px 0 rgba(0, 0, 0, 0.10)',
  size3: '0 4px 8px 0 rgba(0, 0, 0, 0.10)',
  size4: '0 15px 30px 0 rgba(0, 0, 0, 0.10)',
};

export default shadows;
